 <app-header-content-help-text [Heading]="'Stock Criteria'" [helpText]="'Configure Attributes for Inventroy Design'"></app-header-content-help-text>
<app-parameter-table-molecule [fuctionality]="'stockcriteria'"></app-parameter-table-molecule>
